import { useTranslation } from "@redotech/redo-i18n";
import { memo } from "react";
import { Flex } from "../../../flex";
import { Text } from "../../../text";
import { DAY_NAMES } from "../utils/date-picker-utils";

export const DayNamesHeader = memo(function DayNamesHeader() {
  const { t } = useTranslation();
  const labels = [
    t("Mo", { context: "Monday abbreviation" }),
    t("Tu", { context: "Tuesday abbreviation" }),
    t("We", { context: "Wednesday abbreviation" }),
    t("Th", { context: "Thursday abbreviation" }),
    t("Fr", { context: "Friday abbreviation" }),
    t("Sat", { context: "Saturday abbreviation" }),
    t("Su", { context: "Sunday abbreviation" }),
  ];
  return (
    <Flex dir="row" gap="none" p="none" w="full">
      {DAY_NAMES.map((day, index) => (
        <Flex
          align="center"
          gap="none"
          grow={1}
          justify="center"
          key={day}
          style={{ height: "40px" }}
        >
          <Text fontSize="sm" fontWeight="medium" textColor="secondary">
            {labels[index]}
          </Text>
        </Flex>
      ))}
    </Flex>
  );
});
